<div class="profile-professional-modal">
  @if (canDismiss()) {
    <close-circle-outline
      class="profile-professional-modal__close"
      (click)="onDismiss()" />
  }

  @let content = currentStep();

  @if (step() > 0) {
    <div
      class="profile-professional-modal__stepper"
      aria-label="Progreso del perfil profesional">
      @for (stepNumber of steps; track stepNumber; let last = $last) {
        <div class="profile-professional-modal__stepper-item">
          <span
            class="profile-professional-modal__stepper-number body-xs"
            [class.profile-professional-modal__stepper-number--active]="
              step() >= stepNumber
            "
            [attr.aria-current]="step() === stepNumber ? 'step' : null">
            {{ stepNumber }}
          </span>
          @if (!last) {
            <span
              class="profile-professional-modal__stepper-connector"
              [class.profile-professional-modal__stepper-connector--active]="
                step() >= stepNumber
              ">
            </span>
          }
        </div>
      }
    </div>
  }

  @for (paneStep of [step()]; track paneStep) {
    <div
      class="wizard-pane"
      [class.wizard-pane--back]="navDir() === 'back'">
  @if (imageSrc(); as imageSrc) {
    <ui-image
      class="profile-professional-modal__image"
      [src]="imageSrc"
      alt=""
      aspectRatio="4/3"
      fitBy="height"
      objectFit="contain" />
  }

  <div class="profile-professional-modal__header">
    <h3 class="profile-professional-modal__header-title">
      @for (part of content.titleParts; track part.text) {
        @if (part.gradient) {
          <span class="text-gradient-primary">{{ part.text }}</span>
        } @else {
          {{ part.text }}
        }
      }
    </h3>
    <p class="profile-professional-modal__header-description">
      {{ content.description }}
    </p>

    @if (step() === 0) {
      <tag
        class="profile-professional-modal__header-tag"
        [active]="true"
        [icon]="ClockOutline"
        label="Solo 4 preguntas" />
    }
  </div>

  @if (step() > 0) {
    @switch (step()) {
      @case (1) {
        <autocomplete-form-control
          [(value)]="profession"
          [options]="professionOptions"
          [required]="true"
          label="Profesión"
          mode="restricted"
          placeholder="Busca tu profesión o carrera" />
        @if (profession() === 'Otro') {
          <input-form-control
            [(value)]="professionOther"
            [required]="true"
            label="Especifica tu profesión o carrera"
            placeholder="Escribe tu profesión" />
        }
      }
      @case (2) {
        <dropdown-form-control
          [(value)]="academicDegree"
          [options]="academicDegreeOptions"
          [required]="true"
          label="Grado académico"
          placeholder="Selecciona tu grado académico" />
        @if (academicDegree() === 'Otro') {
          <input-form-control
            [(value)]="academicDegreeOther"
            [required]="true"
            label="Especifica tu grado académico"
            placeholder="Escribe tu grado académico" />
        }
      }
      @case (3) {
        <dropdown-form-control
          [options]="professionalLineOptions"
          [(value)]="professionalLine"
          label="Área profesional"
          placeholder="Selecciona un área"
          [required]="true" />
        @if (professionalLine() === 'Otro') {
          <input-form-control
            [(value)]="professionalLineOther"
            label="Especifica tu área profesional"
            placeholder="Escribe tu área profesional"
            [required]="true" />
        }
      }
      @case (4) {
        <dropdown-form-control
          [options]="laborSectorOptions"
          [(value)]="laborSector"
          label="Sector laboral"
          placeholder="Selecciona tu sector"
          [required]="true" />
        @if (laborSector() === 'Otro') {
          <input-form-control
            [(value)]="laborSectorOther"
            label="Especifica tu sector laboral"
            placeholder="Escribe tu sector"
            [required]="true" />
        }
      }
    }
  }
    </div>
  }

  <div class="profile-professional-modal__actions">
    @if (step() > 0) {
      <primary-button
        (click)="onBack()"
        [disabled]="loading()"
        [icon]="ArrowLeftOutline"
        iconPosition="left"
        label="Atrás"
        size="medium"
        variant="secondary"
        class="profile-professional-modal__action" />
    }
    <primary-button
      (click)="onNext()"
      [disabled]="!canContinue()"
      [icon]="step() === 4 ? SendTwo : ArrowRightOutline"
      [label]="step() === 4 ? 'Enviar respuestas' : 'Siguiente'"
      [loading]="loading()"
      [variant]="buttonVariant"
      size="medium"
      class="profile-professional-modal__action" />
  </div>

  <div class="profile-professional-modal__footer">
    <shield-lock-bold class="profile-professional-modal__footer-icon" />
    <span>Tu información está segura con nosotros</span>
  </div>
</div>
